"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineMinimal = void 0;
var jsx_runtime_1 = require("preact/jsx-runtime");
var SimpleDate_1 = require("../Date/SimpleDate");
var CancelledIcon_1 = require("./defaultIcons/CancelledIcon");
var PendingIcon_1 = require("./defaultIcons/PendingIcon");
var CollectedIconBase_1 = require("./icons/CollectedIconBase");
var CompletedIconBase_1 = require("./icons/CompletedIconBase");
var ConfirmedIconBase_1 = require("./icons/ConfirmedIconBase");
var InTransitIconBase_1 = require("./icons/InTransitIconBase");
var SecondaryStep_1 = require("./SecondaryStep");
var InvisibleStep = function () {
    return ((0, jsx_runtime_1.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", width: "8", height: "8", viewBox: "0 0 8 8", fill: "none" }));
};
var Step = function (_a) {
    var config = _a.config, shipment = _a.shipment, idx = _a.idx;
    var shouldRenderInvisibleStep = function () {
        var status = shipment.status, quote_type = shipment.quote_type;
        switch (status) {
            case 'confirmed':
                return quote_type === 'self_ship' ? idx < 3 || idx === 5 : idx < 3;
            // Theoretically self_ship should never have a collected status
            // But handle it just in case
            case 'collected':
                return quote_type === 'self_ship'
                    ? idx < 2 || idx > 3
                    : idx < 2 || idx > 4;
            case 'in_transit':
                return quote_type === 'self_ship'
                    ? idx < 2 || idx > 3
                    : idx < 1 || idx > 3;
            case 'completed':
                return quote_type === 'self_ship' ? idx > 2 || idx === 0 : idx > 2;
            default:
                return true;
        }
    };
    if (shouldRenderInvisibleStep()) {
        return (0, jsx_runtime_1.jsx)(InvisibleStep, {});
    }
    return (0, jsx_runtime_1.jsx)(SecondaryStep_1.SecondaryStep, { config: config });
};
var TimelineMinimal = function (_a) {
    var config = _a.config, shipment = _a.shipment;
    var labelMap = {
        pending: 'pendingLabel',
        confirmed: 'confirmedLabel',
        in_transit: 'inTransitLabel',
        collected: 'collectedLabel',
        completed: 'completedLabel',
        cancelled: 'cancelledLabel',
    };
    var dateMap = {
        pending: 'created_at',
        confirmed: 'confirmed_at',
        collected: 'collected_at',
        in_transit: 'in_transit_at',
        completed: 'completed_at',
        cancelled: 'cancelled_at',
    };
    return ((0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__timeline__minimal__wrapper", children: shipment.status === 'cancelled' || shipment.status === 'pending' ? (shipment.status === 'pending' ? ((0, jsx_runtime_1.jsx)(PendingIcon_1.PendingIcon, { config: config })) : ((0, jsx_runtime_1.jsx)(CancelledIcon_1.CancelledIcon, { config: config }))) : ((0, jsx_runtime_1.jsxs)("div", { class: "artajs__tracking__timeline__minimal__divider", children: [(0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__timeline__minimal__step", children: (0, jsx_runtime_1.jsxs)("div", { class: "artajs__tracking__timeline__minimal__spacing", children: [(0, jsx_runtime_1.jsx)(Step, { config: config, shipment: shipment, idx: 0 }), (0, jsx_runtime_1.jsx)(Step, { config: config, shipment: shipment, idx: 1 }), (0, jsx_runtime_1.jsx)(Step, { config: config, shipment: shipment, idx: 2 }), shipment.status === 'confirmed' && ((0, jsx_runtime_1.jsx)(ConfirmedIconBase_1.ConfirmedIconBase, { config: config })), shipment.status === 'collected' && ((0, jsx_runtime_1.jsx)(CollectedIconBase_1.CollectedIconBase, { config: config })), shipment.status === 'in_transit' && ((0, jsx_runtime_1.jsx)(InTransitIconBase_1.InTransitIconBase, { config: config })), shipment.status === 'completed' && ((0, jsx_runtime_1.jsx)(CompletedIconBase_1.CompletedIconBase, { config: config })), (0, jsx_runtime_1.jsx)(Step, { config: config, shipment: shipment, idx: 3 }), (0, jsx_runtime_1.jsx)(Step, { config: config, shipment: shipment, idx: 4 }), (0, jsx_runtime_1.jsx)(Step, { config: config, shipment: shipment, idx: 5 })] }) }), (0, jsx_runtime_1.jsxs)("div", { class: "artajs__tracking__timeline__status__text__wrapper", children: [(0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__timeline__status__text__large", children: config.text[labelMap[shipment.status]] }), (0, jsx_runtime_1.jsx)(SimpleDate_1.SimpleDate, { date: shipment[dateMap[shipment.status]], dateConfig: config.text.dates })] })] })) }));
};
exports.TimelineMinimal = TimelineMinimal;
